import { useMemo } from "react";
import { useConditional } from "../../core/hooks/useConditional";
import { useEntityLookup } from "../../core/hooks/useEntityLookup";
import { Modal } from "../../core/ui/Modal";
import { Table } from "../../core/ui/Table";
import { Icon } from "../../core/ui/icons";
import { first, last } from "../../core/utils/array";
import { DateCol, GenericCol } from "../../layout/TableCells";
import { Address, AddressType, CompanyOfficer, getAddressTypeName } from "../../types";
import { EditTrackedItem } from "./EditTrackedItem";
import { formatData } from "./Format";
import { HistoryModal } from "./HistoryModal";
import { TrackedItemDisplay } from "./TrackedItemDisplay";
import { parseTrackedItems } from "./parseTrackedItem";

// export function AddressDisplay(props: {
// 	address: Address,
// }) {

// 	const { address } = props;

// 	const format = address ? {
// 		lines: [
// 			{
// 				parts: [address.careOf],
// 			},
// 			{
// 				parts: [address.line2],
// 			},
// 			{
// 				parts: [address.street],
// 			},
// 			{
// 				parts: [address.locality, address.state, address.postCode],
// 				separator: " ",
// 			},
// 			{
// 				parts: [address.country],
// 			},
// 		]		
// 	} : undefined;

// 	return (
// 		formatData(format)
// 	);
// }

// export function AddressCol() {
// 	return {
// 		renderTitle: (c: any) => {
// 			return "Name";
// 		},
		
// 		renderValue: (r: any, c: any) => {
// 			const address = r as Address;			
// 			return <AddressDisplay address={address} />;
// 		}	
// 	};
// }

export function CompanyOfficers(props: {
	officers: CompanyOfficer[],
}) {

	const entities = useEntityLookup(props.officers);

	const sorted = useMemo(() => {
		if (!props.officers) return;

		props.officers.sort((a, b) => {

			let i = (a.entity.localeCompare(b.entity));
			if (i !== 0) return i;

			i = a.type.localeCompare(b.type);
			if (i !== 0) return i;

			i = a.effective.localeCompare(b.effective);
			return i;
		});

		return props.officers;

	}, [props.officers]);


	const items = [] as any[];

	function addSection(title: string, rows: any[]) {
		items.push(
			<div key={title} className="margin-bottom-10">
				<h3>{title}</h3>
				<Table
					cols={[
						GenericCol("Position", "type"),
						GenericCol("Status", "status"),
						GenericCol("Meeting", "meetingStatus"),
						DateCol("Appointed", "effective"),
						DateCol("Ceased", "ceased"),
					]}
					items={rows}
				/>
			</div>
		)
	}

	if (sorted && entities.map) {
		let rows = [] as any;
		let lastEntity = "";

		for(let o of sorted) {
			const e = entities.map[o.entity];
			if (e.title !== lastEntity) {
				if (rows.length > 0) addSection(lastEntity, rows);

				lastEntity = e.title;
				rows = [];
			}

			rows.push(o);
		}
		if (rows.length > 0) addSection(lastEntity, rows);
	}

	return (
		<div>
			{items}
		</div>
	);
}

//function 